import React, { useState } from 'react'
import { Button, Glyphicon } from 'react-bootstrap'

type Props = {
  addSubadmin: Function,
  availableTerminals: Array<{ _id: String, name: String, area: String }>,
}

const AddSubadminBox = ({ addSubadmin, availableTerminals }: Props) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [terminals, setTerminals] = useState(availableTerminals.map((t) => ({ ...t, checked: false })))

  const onTerminalCheck = (terminal, checked) => {
    const idx = terminals.find((t) => t._id === terminal._id)
    setTerminals([...terminals.slice(0, idx), { ...terminal, checked }, ...terminals.slice(idx + 1)])
  }

  return (
    <div style={{ background: '#fff', marginBottom: 20, padding: 7 }}>
      <input className="change-input form-control" placeholder="Förnamn & Efternamn *" onChange={(e) => setName(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Email *" onChange={(e) => setEmail(e.target.value.trim())} type="text" />
      <input className="change-input form-control" placeholder="Tel" onChange={(e) => setPhone(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Lösenord *" onChange={(e) => setPassword(e.target.value)} type="text" />
      <h4>Tillgång till åkerier:</h4>
      {availableTerminals.map((terminal) => (
        <div key={terminal._id}>
          <label style={{ fontSize: 16 }}>
            <input onChange={(e) => onTerminalCheck(terminal, e.target.checked)} type="checkbox" value={terminal._id} />
            {terminal.company}
          </label>
        </div>
      ))}
      <Button disabled={!email || !password} onClick={() => addSubadmin({ password, name, email, phone, terminals: terminals.reduce((acc, t) => (t.checked ? acc.concat(t._id) : acc), []) })} className="btn btn-primary" bsSize="small" style={{ backgroundColor: '#006e78' }} block>
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara lokaladmin
      </Button>
    </div>
  )
}

export default AddSubadminBox
